// @ts-check
import { Flex, Padding, Separator } from 'components/base/layout-components';
import styled from 'styled-components';
import Text from 'components/base/Text';
import { LBButton } from '@linearb/buzz';

const StyledSeparator = styled(Separator)`
  display: horizontal;
  width: 100%;
  height: 1px;
  margin: 2rem 0;
`;

export const TakeParentIncidentsSettingsModal = ({
  parentName,
  onSaveParentConfig,
  toggleModal
}) => {
  return (
    <Flex padding='2rem' direction='column'>
      <Text size='x-x-large'>Override CFR & MTTR Configuration</Text>
      <StyledSeparator />
      <Flex mb='small' mt='small' direction='column'>
        <Text size='x-medium' lineHeight='1.7rem'>
          Changing the configuration to <b>{parentName}</b> will override the
          current configuration. Please note that they cannot be restored.
        </Text>
        <br />
        <Text size='x-medium'>Are you sure you wish to override?</Text>
      </Flex>
      <StyledSeparator />
      <Flex direction='row-reverse'>
        <Padding l='small'>
          <LBButton
            onClick={async () => {
              await onSaveParentConfig();
              toggleModal();
            }}
          >
            Save
          </LBButton>
        </Padding>

        <LBButton variant='outline' onClick={() => toggleModal()}>
          Cancel
        </LBButton>
      </Flex>
    </Flex>
  );
};
